// Menu — dropdown built on Base UI's headless Menu primitive.
//
// Replaces hand-rolled absolutely-positioned dropdowns (manual outside-click
// handlers, no keyboard nav). Base UI gives us focus management, ↑/↓ navigation,
// Esc-to-close, portal positioning and click-outside for free.
//
// Usage:
//   <Menu trigger={<><Icon/> 工具 ▾</>} triggerClassName="btn btn-sm" minWidth={220}>
//     <MenuItem icon={IconDollar} onClick={...}>批量改价</MenuItem>
//     <MenuNote>更多工具开发中…</MenuNote>
//   </Menu>

import React from 'react';
import { Menu as BaseMenu } from '@base-ui/react/menu';

const POPUP_STYLE = {
  background: 'var(--bg-1)',
  border: '1px solid var(--line-2)',
  borderRadius: 8,
  padding: 4,
  boxShadow: '0 12px 32px rgba(0,0,0,0.5)',
  fontSize: 13,
  color: 'var(--fg-1)',
  outline: 'none',
};

const ITEM_STYLE = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: '100%',
  padding: '7px 10px',
  borderRadius: 5,
  cursor: 'pointer',
  outline: 'none',
  textAlign: 'left',
  fontSize: 13,
  userSelect: 'none',
};

export const Menu = ({
  trigger,
  triggerClassName = '',
  triggerStyle,
  disabled = false,
  title,
  minWidth = 200,
  align = 'start',
  sideOffset = 6,
  children,
}) => (
  <BaseMenu.Root>
    <BaseMenu.Trigger
      className={triggerClassName}
      disabled={disabled}
      title={title}
      style={triggerStyle}
    >
      {trigger}
    </BaseMenu.Trigger>
    <BaseMenu.Portal>
      <BaseMenu.Positioner side="bottom" align={align} sideOffset={sideOffset} style={{ zIndex: 100 }}>
        <BaseMenu.Popup style={{ ...POPUP_STYLE, minWidth }}>
          {children}
        </BaseMenu.Popup>
      </BaseMenu.Positioner>
    </BaseMenu.Portal>
  </BaseMenu.Root>
);

export const MenuItem = ({ icon: Icon, children, onClick, danger = false, disabled = false }) => (
  <BaseMenu.Item
    className="ui-menu-item"
    disabled={disabled}
    onClick={onClick}
    style={{ ...ITEM_STYLE, color: danger ? 'var(--err)' : 'var(--fg-1)' }}
  >
    {Icon && <Icon size={13} style={{ flexShrink: 0 }} />}
    <span style={{ flex: 1, minWidth: 0 }}>{children}</span>
  </BaseMenu.Item>
);

// 非可点击的说明行(如"更多工具开发中…")。
export const MenuNote = ({ children }) => (
  <div className="micro" style={{ padding: '7px 10px 3px', color: 'var(--fg-3)', textTransform: 'none', letterSpacing: 0 }}>
    {children}
  </div>
);

export const MenuSeparator = () => (
  <BaseMenu.Separator style={{ height: 1, background: 'var(--line)', margin: '4px 0' }} />
);
